package de.xtl.retroguide

import de.xtl.retroguide.protocol.SessionAccess
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

class SessionAccessStorage(
    private val readText: () -> String? = { null },
    private val writeText: (String?) -> Unit = {},
) {
    fun load(): SessionAccess? = readText()?.let { runCatching { Json.decodeFromString<SessionAccess>(it) }.getOrNull() }

    fun save(access: SessionAccess) = writeText(Json.encodeToString(access))

    fun clear() = writeText(null)
}
